import styled from 'styled-components';
export const InfiniteScrollContainer = styled.div `
  display: flex;
  flex-direction: column-reverse;
  flex-grow: 1;
  overflow: auto;
  background: #f7f7f8;
`;
export const MessageListContainer = styled.div `
  display: flex;
  flex-direction: column-reverse;
  padding: 0 20px;
`;
//# sourceMappingURL=styles.js.map